goog.require("el8.app.setup");
goog.require("el8.data.practiceUsers");
goog.require("el8.util.amplitude.helpers");

var el8 = el8 || {};
if (!el8.main) {
  el8.main = {};
}
el8.main.onboardingReg = {};

el8.main.onboardingReg.init = function(spec) {
  spec["layout"] = { innerContainerSelector: "#root", notLegacy: true };
  spec["init_status"] = false;
  // Initializes el8 globals and enables legacy header nav links
  el8.app.setup(spec);

  el8.util.amplitude.logEvent(
    "Landed on Onboarding Registration in Onboarding",
    { "Current Step": "Onboarding Registration" }
  );
};
